import { clientFetch } from '~/api/clientFetch';

export async function sendBulkReminder(signOut: () => void): Promise<void> {
  await clientFetch(`/users/bulk_login_reminders`, { method: 'POST' }, signOut);
}
